<template>
<div class="mod-config">
    <div style="border-radius: 30px">
        <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-row>
              <el-form-item label="申请单号:" prop="applyformNum">
                <el-input size="small" v-model="dataForm.applyformNum" placeholder="申请单号" clearable @blur="getDataList"></el-input>
              </el-form-item>
                <el-form-item label="状态" prop="applyStatus">
                        <el-select v-model="dataForm.applyStatus" clearable placeholder="请选择" @change="getDataList">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                <el-form-item class="fr">
                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left: 20px">查询
                    </el-button>
                    <el-button  v-if ="isAuth('mdata:quotaApply:operationButton')" icon="el-icon-plus" type="primary" @click="newinfor()">新建</el-button>
<!--                    <el-button icon="el-icon-delete" type="primary" @click="handleDelete()">删除</el-button>-->
                </el-form-item>
            </el-row>
        </el-form>
    </div>

    <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName" :height="style.gridStyle.height" @selection-change="selectionChangeHandle" border :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column align="center" v-model="something" type="selection" width="55">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>

            <el-table-column prop="applyformNum" header-align="center" align="center" label="申请单号" min-width="50">
                <template slot-scope="scope">
                    {{ scope.row.applyformNum }}
                </template>
            </el-table-column>
            <el-table-column prop="applyMemo" header-align="center" align="left" label="申请备注" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.applyMemo }}
                </template>
            </el-table-column>
          <el-table-column prop="applyStatus" header-align="center" align="center" label="申请状态" min-width="50">
            <template slot-scope="scope">
              <!-- 根据枚举值显示对应文本 -->
              {{ scope.row.applyStatus === 0 ? '草稿' :
                scope.row.applyStatus === 1 ? '已提交' :
                    scope.row.applyStatus === 2 ? '审批通过':null}}
            </template>
          </el-table-column>
          <el-table-column prop="rejectReason" header-align="center" align="left" label="驳回原因" min-width="130">
            <template slot-scope="scope">
              {{ scope.row.rejectReason }}
            </template>
          </el-table-column>
          <el-table-column
              prop="pic"
              header-align="center"
              align="center"
              width="120"
              label="当前流程图示">
            <template slot-scope="scope">
              <el-link :disabled="scope.row.processStatus === '流程结束'||scope.row.workFlowId === null" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workFlowId, scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
            </template>
          </el-table-column>

          <el-table-column prop="createdName" header-align="center" align="center" width="120" label="申请人">
            <template slot-scope="scope">
              {{ scope.row.createdName }}
            </template>
          </el-table-column>

          <el-table-column prop="createTimeStr" header-align="center" align="center" width="200" label="申请日期" >
            <template slot-scope="scope">
              {{ scope.row.createTimeStr }}
            </template>
          </el-table-column>

          <el-table-column prop="disReason" header-align="center" align="center"  width="100" label="审批历史">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.workFlowId === null " @click="doHistory(scope.row)">查看</el-button>
            </template>
          </el-table-column>

          <el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
            <template slot-scope="scope">
            <template  v-if="scope.row.applyStatus ===0 && scope.row.canEdit">
                  <el-button icon="el-icon-edit" type="text" size="small"
                             @click="handleEdit(scope.row)">编辑
                  </el-button>
                  <el-button  icon="el-icon-edit" type="text" size="small"
                             @click="submitshenqing(scope.row)">提交
                  </el-button>
                  <el-button  icon="el-icon-delete" type="text" size="small" style="color:#F56C6C"
                             @click="handleDelete(scope.row)">删除
                  </el-button>
            </template>
            <el-button icon="el-icon-view" type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
  <el-dialog
      :title="isView ? '查看申请' : (isEdit ? '编辑申请' : '新建申请')"
      :visible.sync="adddialogVisible"
      width="1200px"
      @close="closedialog"
  >
    <!-- 页签容器 -->
    <el-tabs v-model="activeTab" type="card" :closable="closedialog"  :before-leave="handleTabChange">
      <!-- 第一页：申请单创建 -->
      <el-tab-pane label="申请单创建" name="first">
        <el-form ref="firstForm" :model="formData" :rules="formRules" label-width="100px">
          <el-form-item label="子公司：" prop="subcompanyId">
            <div v-if="isView" class="readonly-text">{{this.subcompanyName}}</div>
            <el-select v-else v-model="formData.subcompanyId"  style="width: 100%" :disabled="isView">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 申请备注输入框（必填） -->
          <el-form-item label="申请备注" prop="applyMemo">
            <el-input
                v-model="formData.applyMemo"
                type="textarea"
                rows="3"
                placeholder="请输入申请备注信息"
                :disabled="isView"
            ></el-input>
          </el-form-item>

          <hr />

          <!-- 附件上传区域 -->
          <el-form-item label="附件上传" prop="fileList">
            <div style="display: flex; align-items: center; margin-bottom: 15px;">
              <el-upload
                  v-if="!isView"
                  action
                  :http-request="upload"
                  :data="param"
                  :show-file-list="false"
                  multiple
              >
                <el-button slot="trigger" type="primary">点击上传</el-button>
              </el-upload>
<!--              <div style="margin-left: 20px; color: red;">-->
<!--                <span>*</span>-->
<!--                <span>注：修改部分信息需要上传附件进行作证，否则会被驳回</span>-->
<!--              </div>-->
            </div>

            <!-- 已上传文件列表 -->
            <el-table
                border
                :data="dataList3"
                style="margin-top: 10px"
                v-if="dataList3.length > 0"
            >
              <el-table-column
                  prop="originalName"
                  header-align="center"
                  align="left"
                  label="文件名称"
              ></el-table-column>
              <el-table-column
                  prop="fileSize"
                  header-align="center"
                  align="right"
                  label="文件大小"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  width="180"
                  label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                      v-if="scope.row.fileType === 'application/pdf'"
                      icon="el-icon-view"
                      type="text"
                      @click="viewHandle(scope.row)"
                  >查看</el-button>
                  <el-button
                      v-else
                      icon="el-icon-download"
                      type="text"
                      @click="viewHandle(scope.row)"
                  >下载</el-button>
                  <el-button
                      v-if="!isView"
                      icon="el-icon-delete"
                      type="text"
                      style="color: #F56C6C"
                      @click="deleteFile(scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="dataList3.length === 0" style="color: #F56C6C; margin-top: 10px;">
              请上传至少一个附件
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 第二页：导入配额信息（内容待定） -->
      <el-tab-pane  :label="isView ? '配额信息列表' : '导入配额信息'"
                    name="second"
                   :disabled="secondTabDisabled">

        <!-- 查看模式：显示表格 -->
        <template v-if="isView">
          <div v-loading="viewTableLoading" style="margin-top: 20px;">
            <el-table
                :data="viewTableData"
                border
                size="mini"
                header-align="center"
                align="center"
            >
              <!-- 根据实际接口返回的字段定义表格列 -->
              <el-table-column type="index" width="50" label="序号">
                <template slot-scope="scope">
                  {{ scope.row.applyLineNo }}
                </template>
              </el-table-column>
              <el-table-column prop="syncStatus" header-align="center" align="center" label="同步状态" width="100">
                <template slot-scope="scope">
                  <span :class="getStatusClass(scope.row.syncStatus)">{{getSyncStatus(scope.row.syncStatus)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="matnr" header-align="center" align="center" label="物料编码" width="160">
              </el-table-column>
              <el-table-column prop="matName" header-align="center" align="center" label="物料名称" width="220">
              </el-table-column>
              <el-table-column prop="werks" header-align="center" align="center" label="工厂" width="150">
                <template slot-scope="scope">
                  <span>{{scope.row.werks}}</span>
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" label="A点" width="300">
                <el-table-column prop="lifnr1" header-align="center" align="center" label="供应商代码" width="100">
                </el-table-column>
                <el-table-column prop="lifnr1Name" header-align="center" align="center" label="供应商名称" width="100">
                </el-table-column>
                <el-table-column prop="quote1" header-align="center" align="center" label="配额" width="100">
                </el-table-column>
              </el-table-column>

              <!-- B点 -->
              <el-table-column header-align="center" align="center" label="B点" width="300">
                <el-table-column prop="lifnr2" header-align="center" align="center" label="供应商代码" width="100">
                </el-table-column>
                <el-table-column prop="lifnr2Name" header-align="center" align="center" label="供应商名称" width="100">
                </el-table-column>
                <el-table-column prop="quote2" header-align="center" align="center" label="配额" width="100">
                </el-table-column>
              </el-table-column>

              <!-- C点 -->
              <el-table-column header-align="center" align="center" label="C点" width="300">
                <el-table-column prop="lifnr3" header-align="center" align="center" label="供应商代码" width="100">
                </el-table-column>
                <el-table-column prop="lifnr3Name" header-align="center" align="center" label="供应商名称" width="100">
                </el-table-column>
                <el-table-column prop="quote3" header-align="center" align="center" label="配额" width="100">
                </el-table-column>
              </el-table-column>

              <!-- D点 -->
              <el-table-column header-align="center" align="center" label="D点" width="300">
                <el-table-column prop="lifnr4" header-align="center" align="center" label="供应商代码" width="100">
                </el-table-column>
                <el-table-column prop="lifnr4Name" header-align="center" align="center" label="供应商名称" width="100">
                </el-table-column>
                <el-table-column prop="quote4" header-align="center" align="center" label="配额" width="100">
                </el-table-column>
              </el-table-column>

              <!-- E点 -->
              <el-table-column header-align="center" align="center" label="E点" width="300">
                <el-table-column prop="lifnr5" header-align="center" align="center" label="供应商代码" width="100">
                </el-table-column>
                <el-table-column prop="lifnr5Name" header-align="center" align="center" label="供应商名称" width="100">
                </el-table-column>
                <el-table-column prop="quote5" header-align="center" align="center" label="配额" width="100">
                </el-table-column>
              </el-table-column>
              <el-table-column prop="createByName" header-align="center" align="center" label="创建人" width="100">
              </el-table-column>
              <el-table-column prop="updateByName" header-align="center" align="center" label="更新人" width="100">
              </el-table-column>
              <el-table-column prop="vdatu" header-align="center" align="center" label="起始日期" :formatter="dateFormat" width="150">
              </el-table-column>
              <el-table-column prop="bdatu" header-align="center" align="center" label="有效至" :formatter="dateFormat" width="150">
              </el-table-column>
            </el-table>
            <!-- 无数据提示 -->
            <div v-if="viewTableData.length === 0 && !viewTableLoading" style="text-align: center; padding: 50px 0; color: #999;">
              暂无配额信息数据
            </div>
          </div>
        </template>
        <template v-else>
        <!-- 编辑模式，导入配额信息表单 -->
        <el-form
            :model="importForm"
            ref="importForm"
            @keyup.enter.native="importDataSubmit()"
            label-width="80px"
            style="margin-top: 20px;"
        >
          <el-form-item label="导入模板" prop="file">
            <el-upload
                ref="upload"
                :auto-upload="false"
                drag
                action
                :on-change="handleFileChange"
                :http-request="handleFileUpload"
                :file-list="importFileList"
                accept=".xls"
                :limit="1"
                :on-exceed="handleExceed"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">
                只能上传xls文件，且不超过500kb
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <!-- 第二页底部操作按钮（替代原弹窗footer） -->
        <div style="margin-top: 30px; text-align: right;">
          <el-button @click="exportTemplate()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;导出模板
          </el-button>
          <el-button
              type="primary"
              style="margin-left: 10px;"
              @click="importDataSubmit()"
          >
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确认导入
          </el-button>
        </div>
        </template>
      </el-tab-pane>
    </el-tabs>

    <!-- 弹窗底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="closedialog">取消</el-button>
      <el-button
          type="primary"
          @click="handleFirstSave"
          v-if="activeTab === 'first' && !isView"
      >
        保存并下一步
      </el-button>
<!--      <el-button-->
<!--          type="primary"-->
<!--          @click="handleFinalSave"-->
<!--          v-if="activeTab === 'second'"-->
<!--      >-->
<!--        提交申请-->
<!--      </el-button>-->
    </div>
  </el-dialog>
  <el-dialog
      :visible.sync="showViewer"
      width="80%"
      title="流程图">
    <el-image :src="diagramUrl" style="margin-bottom: 120px;">
    </el-image>
  </el-dialog>
  <el-dialog :visible.sync="showWorkflowDialog" width="70%" title="审批进度" :close-on-click-modal="false">
    <div class="workflow-container">
      <div class="workflow-steps">
        <!-- 节点 1: 提交配额申请 -->
        <div class="step" :class="getStepClass(1, currentWorkflowData)">
          <div class="step-circle">1</div>
          <div class="step-label">提交配额申请</div>
          <div class="step-status">{{ getStepStatusText(1, currentWorkflowData) }}</div>
        </div>

        <!-- 连线 1→2 -->
        <div class="step-line" :class="getLineClass(1, 2, currentWorkflowData)"></div>

        <!-- 节点 2: 采购科长审批 -->
        <div class="step" :class="getStepClass(2, currentWorkflowData)">
          <div class="step-circle">2</div>
          <div class="step-label">采购科长审批</div>
          <div class="step-status">{{ getStepStatusText(2, currentWorkflowData) }}</div>
        </div>

        <!-- 连线 2→3 -->
        <div class="step-line" :class="getLineClass(2, 3, currentWorkflowData)"></div>

        <!-- 节点 3: 采购部长审批 -->
        <div class="step" :class="getStepClass(3, currentWorkflowData)">
          <div class="step-circle">3</div>
          <div class="step-label">采购部长审批</div>
          <div class="step-status">{{ getStepStatusText(3, currentWorkflowData) }}</div>
        </div>

        <!-- 连线 3→4 -->
        <div class="step-line" :class="getLineClass(3, 4, currentWorkflowData)"></div>

        <!-- 节点 4: 采购总监审批 -->
        <div class="step" :class="getStepClass(4, currentWorkflowData)">
          <div class="step-circle">4</div>
          <div class="step-label">采购总监审批</div>
          <div class="step-status">{{ getStepStatusText(4, currentWorkflowData) }}</div>
        </div>

        <!-- 连线 4→5 -->
        <div class="step-line" :class="getLineClass(4, 5, currentWorkflowData)"></div>

        <!-- 节点 5: 流程结束 -->
        <div class="step" :class="getStepClass(5, currentWorkflowData)">
          <div class="step-circle">5</div>
          <div class="step-label">流程结束</div>
          <div class="step-status">{{ getStepStatusText(5, currentWorkflowData) }}</div>
        </div>
      </div>

      <!-- 当前状态说明 -->
      <div class="current-status">
        <h4>当前状态：{{ getCurrentStatusText(currentWorkflowData) }}</h4>
        <p>{{ getCurrentStatusDesc(currentWorkflowData) }}</p>
      </div>
    </div>
  </el-dialog>
  <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
    <div v-for="str in historyList" :key="str">
      <el-descriptions :title="str.executeTime">
        <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
        <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
    </div>
  </el-drawer>
  <pdf-view v-if="pdfPreviewVisible" ref="pdfPreview"></pdf-view>
</div>
</template>

<script>
import {
    saveQuota,
    selectQuotaApplyPage,
    deleteQuotaApply,
    executeQuotaApply
} from '@/controller/mdata'

import {listCommentHistory} from '@/controller/workflow'
import {
    getFileList,
    uploadFile,
    getUrl,
    deleteFileById
} from '@/controller/sys'
import { uuid } from 'vue-uuid'
import {
    FILE_BIZ_TYPE,
    getLabelByValue
} from '@/utils/const'
import {supCompanyList, getUserInfoByToken, getOrgById} from "../../../../controller/sys";
import {
  exportTemplate,
  importQuotaMaterial
} from '@/controller/systemData'
import {getProcessDiagramCurrent} from "../../../../controller/workflow";
import {queryQuotaMaterialByApplyId} from "../../../../controller/mdata";
import moment from "moment";
import {SYNC_STATUS_QUOTA} from "../../../../utils/const";


export default {
  data() {
    return {
      // 核心配置
      FILE_BIZ_TYPE: 35,
      FILE_SUB_TYPE: 11,
      applyStatus: '',
      adddialogVisible: false,
      dataListLoading: false,
      supCompanyList: [],
      showViewer: false,
      diagramUrl: '',
      showWorkflowDialog: false,  // 控制工作流对话框显示
      currentWorkflowData: null, // 当前行数据
      // 表单数据
      dataForm: {
        applyformNum: "",
        applyStatus:null
      },
      formData: {
        subcompanyId: '',
        applyMemo: '' ,// 申请备注
        fileList: []
      },

      importFileList: [], // 上传文件列表
      importForm: {
        file: null // 绑定上传文件
      },
      importLoading: false, // 导入加载状态

      // 列表数据
      dataList: [],
      dataList3: [], // 附件列表
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],

      // 样式配置
      style: {
        gridStyle: {
          height: parseInt(document.documentElement["clientHeight"]) - 215 + "px",
        },
      },

      // 状态选项
      options1: [
        { label: '草稿', value: 0 },
        { label: '已提交', value: 1 },
        { label: '审批通过', value: 2 }
      ],

      // 文件上传参数
      param: {
        bizId: '',
        bizType: '',
        fileSubType: '',
      },
      fileId: '',
      applyFormFid: null,
      fileOperationState: null, // 文件操作状态 1新建 2编辑

      // 弹窗页签
      activeTab: 'first',

      // 新增状态控制变量
      isSaving: false, // 保存操作加载状态
      secondTabDisabled: true, // 第二页签是否禁用
      firstPageSaved: false, // 第一页是否已成功保存
      applyFormId: null, // 保存后获取的申请单ID
      isEdit: false, // 标记是否为编辑模式
      currentEditId: null,// 当前编辑的申请单ID
      userInfo:{},
      // 审批历史
      drawer: false,
      // 审批列表
      historyList:[],
      pdfPreviewVisible:false,
      //查看模式
      isView: false,
      viewTableData: [],
      viewTableLoading: false,
      SYNC_STATUS_QUOTA: SYNC_STATUS_QUOTA,// 同步状态
      subcompanyName:'',
      statusPriority: {
        '提交配额申请': 1,
        '采购科长审批': 2,
        '采购部长审批': 3,
        '采购总监审批': 4,
        '流程结束': 5
      },
    };
  },

  activated() {
    this.fileId = uuid.v1();
    this.getDataList();
    this.getAllStatus();
    this.getSupCompanyList();
    // 获取当前登录人员信息
    getUserInfoByToken({}).then(data => {
      if (data && data.code === '00') {
        this.userInfo = data.body.user
      }
    })
  },

  computed: {
    formRules() {
      return {
        applyMemo: [
          { required: true, message: '请输入申请备注', trigger: 'blur' }
        ],
        fileList: [
          {
            required: true,
            // 直接内联验证逻辑，避免this指向问题
            validator: (rule, value, callback) => {
              console.log('验证时的this:', this); // 应指向Vue实例
              console.log('附件数量:', this.dataList3.length); // 应正确显示上传的附件数
              if (this.dataList3.length === 0) {
                callback(new Error('请先上传附件'));
              } else {
                callback();
              }
            },
            trigger: 'blur' // 改为blur或手动触发
          }
        ],
        subcompanyId: [
          { required: true, message: '请选择子公司', trigger: 'blur' }
        ]
      };
    }
  },

  methods: {
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1;
      this.getDataList();
    },

    // 分页相关
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    // 多选事件
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },

    // 序号计算
    rowClassName({ row, rowIndex }) {
      row.rowid = rowIndex + 1 + this.pageSize * (this.pageIndex - 1);
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      selectQuotaApplyPage({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        applyStatus: this.dataForm.applyStatus,
        applyformNum: this.dataForm.applyformNum
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records;
          this.totalPage = data.body.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
      }).catch((e) => {
        console.error(e);
      }).finally(() => {
        this.dataListLoading = false;
      });
    },

    // 新建弹窗
    newinfor() {
      //重置也签状态
      this.activeTab = 'first';
      this.secondTabDisabled = true;
      this.firstPageSaved = false;
      this.getSupCompanyList();
      this.fileOperationState = 1;
      this.selectFileList(this.fileId);
      // 用$nextTick确保activeTab更新后再打开弹窗
      this.$nextTick(() => {
        this.adddialogVisible = true;
      });
    },

    // 提交申请
    submitshenqing(row){
      executeQuotaApply(row).then(data => {
        if(data && data.code === '00'){
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.getDataList()
            }
          })
        }else{
          this.$message.error(data.msg)
        }
      }).catch(()=>{}).finally(()=>{})
    },

    // // 获取状态列表
    // getAllStatus() {
    //   listAllStatus({
    //     processDefKey: 'SCI0'
    //   }).then(data => {
    //     if (data && data.code === '00') {
    //       this.options1 = data.body.map(str => ({ value: str, label: str }));
    //     }
    //   });
    // },

    // 文件上传
    upload(obj) {
      const id = this.fileOperationState === 1 ? this.fileId : this.applyFormFid;

      const formData = new FormData();
      formData.set('file', obj.file);
      formData.set('fileName', obj.file.name);
      formData.set('id', id);
      formData.set('bizType', this.FILE_BIZ_TYPE);
      formData.set('fileSubType', this.FILE_SUB_TYPE);

      const fileDir = getLabelByValue(FILE_BIZ_TYPE, this.FILE_BIZ_TYPE);
      if (fileDir) {
        formData.set('fileDir', fileDir);
      } else {
        this.$message.error("请先配置附件的业务类型！");
        return;
      }

      uploadFile(formData).then(data => {
        if (data.code === '00') {
          this.selectFileList(id);
          this.$message.success('上传成功！');
        } else {
          this.$message.warning(data.msg);
        }
      });
    },

    // 查询文件列表
    selectFileList(id) {
      getFileList({
        id,
        bizType: this.FILE_BIZ_TYPE
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList3 = data.body;
        } else {
          this.dataList3 = [];
        }
      });
    },

    // 查看/下载文件
    // viewHandle(row) {
    //   getUrl({ fileId: row.id }).then(data => {
    //     if (data && data.code === '00' && data.body) {
    //       if (row.fileType === 'application/pdf') {
    //         window.open(data.body, '_blank'); // 直接在新窗口打开PDF
    //       } else {
    //         this.download(data.body, row.originalName);
    //       }
    //     }
    //   });
    // },


    // 查看/下载文件
    viewHandle(row) {
      console.log(row, 'row')
      getUrl({
        'fileId': row.id
      }).then(data => {
        if (data && data.code === '00' && data.body) {
          // location.href=data.body;
          if (row.fileType === 'application/pdf') {
            window.open(data.body, '_blank')
          } else {
            this.download(data.body, row.originalName)
          }
        } else {
          this.tableData = []
        }
      })
    },

    previewPdf(pdfUrl) {
      this.pdfPreviewVisible = true
      this.$nextTick(() => {
        //此处参数传入pdf文件的地址
        this.$refs.pdfPreview.init(pdfUrl)
      })
    },

    download(url, filename) {
      const _this = this
      this.getBlob(url, function (blob) {
        _this.saveAs(blob, filename);
      });
    },

    // // 文件下载工具
    // download(url, filename) {
    //   this.getBlob(url, (blob) => {
    //     this.saveAs(blob, filename);
    //   });
    // },
    getBlob(url, cb) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = () => xhr.status === 200 && cb(xhr.response);
      xhr.send();
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    },

    // 删除文件
    deleteFile(row) {
      const id = this.fileOperationState === 1 ? this.fileId : this.applyFormFid;

      this.$confirm(`确定删除该文件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteFileById({ fileId: row.id }).then(data => {
          if (data.code === '00') {
            this.selectFileList(id);
            this.$message.success('删除成功！');
          }
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    // 表单验证 - 文件列表
    validateFileList(rule, value, callback) {
      if (this.dataList3.length === 0) {
        callback(new Error('请先上传附件'));
      } else {
        callback();
      }
    },

    handleTabChange(from, to) {
      // 从第一页切换到第二页时验证是否已保存
      if (from === 'first' && to === 'second' && !this.firstPageSaved) {
        this.$message.warning('请先完成第一页保存');
        return false; // 阻止切换
      }
      return true; // 允许其他切换
    },
// 新增：工作流相关方法
viewDiagram(id, row) {
  // 如果能找到对应行数据，则使用新的工作流对话框
  if (row) {
    this.currentWorkflowData = row;
    this.showWorkflowDialog = true;
  } else {
    // 否则使用原来的流程图查看功能
    getProcessDiagramCurrent({id: id}).then(data => {
      this.diagramUrl = data.body;
      this.showViewer = true;
    });
  }
},
    getStepClass(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      return {
        'step-completed': status === 'completed',
        'step-current': status === 'current',
        'step-pending': status === 'pending'
      };
    },
    // 获取连线样式类
    getLineClass(fromStep, toStep, rowData) {
      const fromStatus = this.getStepStatus(fromStep, rowData);
      const toStatus = this.getStepStatus(toStep, rowData);

      // 如果前一个节点已完成，连线显示为完成状态
      if (fromStatus === 'completed' && (toStatus === 'current' || toStatus === 'completed')) {
        return 'line-completed';
      }
      // 如果前一个节点是进行中，且后一个节点是当前节点
      else if (fromStatus === 'current' && toStatus === 'current') {
        return 'line-active';
      }
      return 'line-pending';
    },

    // 获取步骤状态
    getStepStatus(step, rowData) {
      const status = rowData ? rowData.processStatus : '';
      const priority = this.statusPriority[status] || 0;

      // 定义各状态的预期流程
      const statusSequence = [
        {step: 1, name: '提交配额申请', requiredStatus: '提交配额申请'},
        {step: 2, name: '采购科长审批', requiredStatus: '采购科长审批'},
        {step: 3, name: '采购部长审批', requiredStatus: '采购部长审批'},
        {step: 4, name: '采购总监审批', requiredStatus: '采购总监审批'},
        {step: 5, name: '流程结束', requiredStatus: '流程结束'}
      ];

      // 找到当前步骤对应的配置
      const currentStepConfig = statusSequence.find(s => s.step === step);
      if (!currentStepConfig) return 'pending';

      // 如果当前状态等于该步骤的状态，则为进行中
      if (status === currentStepConfig.requiredStatus) {
        return 'current';
      }

      // 如果当前状态优先级高于该步骤的状态，则为已完成
      if (priority > this.statusPriority[currentStepConfig.requiredStatus]) {
        return 'completed';
      }

      // 否则为待处理
      return 'pending';
    },

    // 获取步骤状态文本
    getStepStatusText(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      switch (status) {
        case 'completed':
          return '✓ 已完成';
        case 'current':
          return '▶ 进行中';
        case 'pending':
          return '○ 待处理';
        default:
          return '';
      }
    },

    // 获取当前状态文本
    getCurrentStatusText(rowData) {
      const statusMap = {
        '提交配额申请': '提交配额申请',
        '采购科长审批': '等待采购科长审批',
        '采购部长审批': '等待采购部长审批',
        '采购总监审批': '等待采购总监审批',
        '流程结束': '流程已完成'
      };

      if (rowData && rowData.processStatus) {
        return statusMap[rowData.processStatus] || rowData.processStatus;
      }

      return '';
    },

    // 获取当前状态描述
    getCurrentStatusDesc(rowData) {
      const descMap = {
        '提交配额申请': '正在提交配额申请',
        '采购科长审批': '采购科长正在审核配额申请',
        '采购部长审批': '采购部长正在审核配额申请',
        '采购总监审批': '采购总监正在审核配额申请',
        '流程结束': '所有审批环节已完成，配额申请通过'
      };

      if (rowData && rowData.processStatus) {
        return descMap[rowData.processStatus] || '暂无状态描述';
      }

      return '暂无状态描述';
    },
    // 第一页保存
    handleFirstSave() {
      this.$refs.firstForm.validate((valid) => {
        console.log("表单验证结果:",valid);
        if (valid) {
          // 表单验证通过，开始保存
          this.isSaving = true; // 开启加载状态

          // 调用保存接口（根据实际接口调整参数）
          saveQuota({
            applyMemo: this.formData.applyMemo, // 申请备注
            fileId: this.fileId, // 文件关联ID
            subcompanyId: this.formData.subcompanyId,
            bizType: this.FILE_BIZ_TYPE, // 业务类型
            id:this.currentEditId
          }).then(data => {
            this.isSaving = false; // 关闭加载状态

            if (data && data.code === '00') {
              // 保存成功
              this.$message.success('第一页数据保存成功');
              this.firstPageSaved = true; // 标记已保存
              this.secondTabDisabled = false; // 启用第二页
              this.applyFormId = data.body; // 保存接口返回的申请单ID
              this.activeTab = 'second'; // 切换到第二页
            } else {
              // 保存失败
              this.$message.error(data?.msg || '第一页数据保存失败');
            }
          }).catch(error => {
            this.isSaving = false; // 关闭加载状态
            console.error('保存接口调用失败', error);
            this.$message.error('网络异常，保存失败');
          });
        } else {
          // 表单验证失败
          const errorEl = document.querySelector('.el-form-item__error');
          errorEl && errorEl.scrollIntoView({ behavior: 'smooth' });
          return false;
        }
      });
    },

    // 获取子公司列表
    getSupCompanyList() {
      supCompanyList().then(res => {
        if (res && res.code === '00') {
          this.supCompanyList = res.body;

          // 自动选择逻辑：如果只有一个子公司，自动选中
          if (this.supCompanyList.length === 1) {
            this.dataForm.subcompanyId = this.supCompanyList[0].id;
          } else {
            this.dataForm.subcompanyId = null;
          }
        }
      });
    },

    // 审批历史
    doHistory(row){
      this.historyList = []
      listCommentHistory({'workflowId' : row.workFlowId}).then(data => {
        if (data && data.code === '00') {
          this.historyList = data.body
        } else {
          this.$message.error(data.msg)
        }
      })
      this.drawer = true
    },

// 编辑方法：点击编辑按钮时触发
    handleEdit(row) {
      // 1. 标记编辑状态，记录当前编辑ID
      this.isEdit = true;
      this.currentEditId = row.id;
      this.fileOperationState = 2; // 标记为编辑模式（附件操作使用）
      this.applyFormFid=row.id;

      this.activeTab = 'first';
      this.secondTabDisabled = true;
      this.firstPageSaved = false;

      // 2. 重置弹窗表单状态
      this.adddialogVisible = false; // 先关闭弹窗避免闪烁
      if (this.$refs.firstForm) {
        this.$refs.firstForm.resetFields(); // 重置表单验证
      }

      // 3. 填充表单基础数据（子公司、申请备注）
      this.formData = {
        subcompanyId: row.subcompanyId, // 子公司ID（对应选中行的子公司ID）
        applyMemo: row.applyMemo || '', // 申请备注（对应选中行的备注字段，根据实际数据结构调整）
        fileList: [],

      };

      // 4. 加载附件列表（通过申请单ID获取关联附件）
      this.selectFileList1(row.id).then(() => {
        // 5. 确保子公司列表已加载（避免下拉选项为空）
        this.getSupCompanyList1().then(() => {
          // 6. 打开弹窗并设置页签状态
          this.adddialogVisible = true; // 显示弹窗
          this.activeTab = 'first'; // 显示第一页签
          this.secondTabDisabled = false; // 允许切换到第二页签
          this.firstPageSaved = true; // 标记第一页数据已加载
        });
      });
    },
    //编辑查询方法
    selectFileList1(id) {
      // 明确返回一个 Promise
      return new Promise((resolve, reject) => {
        getFileList({
          id,
          bizType: this.FILE_BIZ_TYPE
        }).then(data => {
          if (data && data.code === '00') {
            this.dataList3 = data.body;
          } else {
            this.dataList3 = [];
          }
          resolve(); // 成功时调用 resolve
        }).catch(error => {
          this.dataList3 = [];
          reject(error); // 失败时调用 reject
        });
      });
    },
    getSupCompanyList1() {
      // 明确返回一个 Promise
      return new Promise((resolve, reject) => {
        supCompanyList().then(res => {
          if (res && res.code === '00') {
            this.supCompanyList = res.body;
            // 编辑时保持原有选中的子公司，不需要自动选择
          }
          resolve(); // 成功时调用 resolve
        }).catch(error => {
          reject(error); // 失败时调用 reject
        });
      });
    },

    // 删除配额申请单
    handleDelete(row){
      this.$confirm(`确定进行删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataListLoading = true
        deleteQuotaApply(
            {
              id : row.id
            }
        ).then(data => {
          if(data && data.code === '00'){
            this.dataListLoading = false
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.getDataList()
              }
            })
          }else{
            this.dataListLoading = false
            this.$message.error(data.msg)
          }
        }).catch(()=>{
          this.dataListLoading = false
        }).finally(()=>{
          this.dataListLoading = false
        })

      })
    },

    handleFileChange(file, fileList){
      this.fileList = fileList.slice(-1);
    },

    handleFileUpload(obj) {
      console.log("保存返回的申请单ID", this.applyFormId)
      let formData = new FormData()
      if(this.currentEditId==null){
        formData.set('applyFormId', this.applyFormId); // 关联申请单ID
      }
      else{
        formData.set('applyFormId', this.currentEditId); // 关联申请单ID
      }
      formData.set('file', obj.file)
      formData.set('subcompanyId',this.formData.subcompanyId);
      importQuotaMaterial(formData).then((data) => {
        this.$refs.upload.clearFiles()
        if(data.code === '00'){
          this.$message.success({
            message: '导入成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.$emit("refreshDataList")
              this.adddialogVisible = false;
            }
          })
        } else {
          this.$message.error(data.msg);
          this.visible = false
        }
      }).catch((e) => {
        this.visible = false
        this.$message.error(e);
      })
    },

    // 导出模板
    exportTemplate() {
      exportTemplate().then((data) => {
        this.readAsBinaryString(data.body)
      })
    },

    // 表单提交
    importDataSubmit() {
      this.$refs['importForm'].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        }
      })
    },

    readAsBinaryString(data) {
      // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
      // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
      let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
      dom.style.display = 'none';
      dom.href = url;
      dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
      document.body.appendChild(dom);
      dom.click();
    },
    str2Blob(str, mime) {
      var arr = str.split(',')
      var bstr = atob(arr[0]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },

    // 处理文件超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前只能上传 1 个文件`);
    },


    /**
     * 关闭弹窗时重置状态
     */
    closedialog() {
      this.activeTab = 'first';
      this.$nextTick(() => {
        this.adddialogVisible = false;
        // 重置表单和状态
        this.formData.applyMemo = '';
        this.formData.subcompanyId = '';
        this.dataList3 = [];
        this.firstPageSaved = false;
        this.secondTabDisabled = true;
        this.applyFormId = null;
        this.isSaving = false;
        this.isView = false;
        this.isEdit = false;
        this.currentEditId = null;
        this.queryHandle();
      });
    },

    // viewDiagram(id) {
    //   getProcessDiagramCurrent({id: id}).then(data => {
    //     this.diagramUrl = data.body
    //     this.showViewer = true
    //   })
    // },

    // 查看按钮点击事件
    handleView(row) {
      // 1. 标记为查看模式
      this.isView = true;
      this.isEdit = false; // 清除编辑标记
      this.firstPageSaved = true; // 允许切换到第二页
      this.secondTabDisabled = false; // 启用第二页签

      // 2. 填充第一页表单数据（不可编辑）
      if (row.subcompanyId) {
        getOrgById(
            {},row.subcompanyId
        ).then(data => {
          if (data && data.code === '00') {
            this.subcompanyName = data.body.orgName
          }
        })
      }
      this.formData = {
        subcompanyId: this.subcompanyName,
        applyMemo: row.applyMemo || ''
      };

      // 3. 加载附件列表（查看模式）
      this.applyFormFid = row.id;
      this.selectFileList(row.id); // 复用原有方法加载附件

      // 4. 加载第二页表格数据
      this.getViewTableData(row.id);

      // 5. 打开弹窗并设置页签
      this.$nextTick(() => {
        this.adddialogVisible = true;
        this.activeTab = 'first'; // 默认显示第一页
      });
    },

    // 获取查看模式下第二页表格数据
    getViewTableData(applyId) {
      this.viewTableLoading = true;
      queryQuotaMaterialByApplyId({ id: applyId }).then(data => {
        if (data && data.code === '00') {
          this.viewTableData = data.body;
        } else {
          this.viewTableData = [];
          this.$message.warning('未获取到详情数据');
        }
      }).catch(error => {
        console.error('获取详情列表失败', error);
        this.viewTableData = [];
      }).finally(() => {
        this.viewTableLoading = false;
      });
    },
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (!date) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    getStatusClass(status) {
      let className = ''
      switch (status) {
        case 0:
          className = "text-primary"
          break;
        case 2:
          className = "text-danger"
          break;
        default:
          className = 'text-success'
          break;
      }
      return className
    },

    //获取同步状态
    getSyncStatus(val) {
      var type = this.SYNC_STATUS_QUOTA.find(type => type.value === val)
      return type ? type.label : ''
    },

  }
};
</script>

<style lang="scss">
.button-danger {
  color: #f56c6c;
}

.fr {
  float: right;
}
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 100px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 12px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  width: 100px;
  word-wrap: break-word;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}
</style>